/* Trouser waist picker.
   Shows a "Trouser waist" dropdown right under the option picker whenever the "Set" option is
   "Jacket + Trousers", and sends the choice with the order as the line item property "Trouser size".
   Default = jacket size minus 6 (the store's standard drop). Stays in sync with the Find your size section.
   2026-11-01: also always shown on the Saunter Shirt & Trouser Combo (product tag "shirt-trouser-combo",
   flagged by the section as window.SaunterTrouserCombo). There the default comes from the shirt letter size
   per Terry: S 32, M 34, L 36, XL 38, 2X 40, 3X 42, 4X 44. */
(function () {
  var NAME = "Trouser size", DROP = 6, PANTS = [];
  for (var w = 28; w <= 48; w += 2) PANTS.push(w);
  var COMBO = window.SaunterTrouserCombo === true;
  var LETTER = { "S": 32, "M": 34, "L": 36, "XL": 38, "2X": 40, "XXL": 40, "3X": 42, "XXXL": 42, "4X": 44 };
  var box = null, sel = null, own = false, lastVal = null, syncing = false;

  function vp() { return document.querySelector('variant-picker[context="main_product"]') || document.querySelector("variant-picker"); }
  function fsBy(v, re) {
    var fs = v.querySelectorAll("fieldset");
    for (var i = 0; i < fs.length; i++) { var lg = fs[i].querySelector("legend"); if (lg && re.test(lg.textContent)) return fs[i]; }
    return null;
  }
  function checkedLabel(fs) {
    if (!fs) return "";
    var c = fs.querySelector('input[type="radio"]:checked');
    if (!c) return "";
    var lab = (c.id && fs.querySelector('label[for="' + c.id + '"]')) || c.closest("label");
    return lab ? lab.textContent.replace(/\s+/g, " ").trim() : "";
  }
  function sizeLabel(v) { return checkedLabel(fsBy(v, /^\s*size/i)); }
  function jacketSize(v) { var n = parseInt(sizeLabel(v), 10); return isNaN(n) ? null : n; }
  // null = nothing to do on this product; true/false = trousers wanted or not
  function wantsTrousers(v) {
    if (COMBO) return true;
    var fs = fsBy(v, /^\s*set/i); if (!fs) return null; return /trouser/i.test(checkedLabel(fs));
  }

  function setProp(form, val) {
    var root = document.getElementById("saunter-size-selector") || document.body;
    var el = root.querySelector('input[data-ssz-prop="' + NAME + '"]');
    if (val === null || val === undefined || val === "") { if (el) el.parentNode.removeChild(el); return; }
    if (!el) { el = document.createElement("input"); el.type = "hidden"; el.setAttribute("data-ssz-prop", NAME); root.appendChild(el); }
    el.name = "properties[" + NAME + "]"; el.value = String(val);
    if (form) el.setAttribute("form", form);
  }

  function ensureBox(v) {
    if (box && document.body.contains(box)) return;
    box = document.createElement("div");
    box.id = "tc-trouser-pick";
    box.style.cssText = "margin:14px 0";
    var lab = document.createElement("label");
    lab.setAttribute("for", "tc-trouser");
    lab.style.cssText = "display:block;font-weight:600;margin-bottom:6px";
    lab.textContent = "Trouser waist (inches)";
    sel = document.createElement("select");
    sel.id = "tc-trouser";
    sel.style.cssText = "width:100%;padding:12px;font:inherit;border:1px solid rgba(0,0,0,.35);border-radius:4px;background:#fff;color:inherit";
    PANTS.forEach(function (p) { var o = document.createElement("option"); o.value = String(p); o.textContent = p + '"'; sel.appendChild(o); });
    var note = document.createElement("p");
    note.id = "tc-trouser-note";
    note.style.cssText = "margin:6px 0 0;font-size:13px;opacity:.75";
    box.appendChild(lab); box.appendChild(sel); box.appendChild(note);
    v.parentNode.insertBefore(box, v.nextSibling);
    if (lastVal) sel.value = lastVal;
    sel.onchange = function () { own = true; lastVal = sel.value; commit(); toFinder(parseInt(sel.value, 10)); };
  }

  function commit() {
    var v = vp(); if (!v || !sel) return;
    lastVal = sel.value;
    setProp(v.getAttribute("form-id"), sel.value);
  }

  // Tell the Find your size section about the choice (it keeps its own copy of the trouser size).
  function toFinder(n) {
    var g = document.getElementById("ssz-pant"); if (!g) return;
    var bs = g.querySelectorAll("button");
    syncing = true;
    for (var i = 0; i < bs.length; i++) { if (parseInt(bs[i].textContent, 10) === n) { bs[i].click(); break; } }
    syncing = false;
  }
  function fromFinder() {
    if (syncing || !sel) return;
    var g = document.getElementById("ssz-pant"); if (!g) return;
    var b = g.querySelector('button[aria-pressed="true"]'); if (!b) return;
    var n = parseInt(b.textContent, 10);
    if (n && String(n) !== sel.value) { sel.value = String(n); own = true; commit(); updateNote(); }
  }

  function stdFor(v) {
    if (COMBO) { var l = sizeLabel(v).toUpperCase(); return LETTER[l] || null; }
    var js = jacketSize(v); return js ? Math.max(PANTS[0], Math.min(PANTS[PANTS.length - 1], js - DROP)) : null;
  }
  function updateNote() {
    var v = vp(); var n = document.getElementById("tc-trouser-note"); if (!v || !n) return;
    var s = stdFor(v);
    if (COMBO) {
      n.textContent = s ? 'Trousers included. Standard waist for a size ' + sizeLabel(v) + ' shirt is ' + s + '". Change it if your waist is different.' : "Trousers included. Choose your trouser waist.";
    } else {
      n.textContent = s ? 'Standard trouser for a size ' + jacketSize(v) + ' jacket is ' + s + '". Change it if your trousers are a different waist.' : "Choose the waist size of your trousers.";
    }
  }

  function update() {
    var v = vp(); if (!v) return;
    var w = wantsTrousers(v);
    if (w === null) { if (box) box.hidden = true; return; }   // product has no Set option
    ensureBox(v);
    if (!w) { box.hidden = true; setProp(v.getAttribute("form-id"), null); return; }
    box.hidden = false;
    if (!own) { var s = stdFor(v); sel.value = String(s || (COMBO ? 34 : 36)); }
    updateNote();
    commit();
  }

  function schedule() { update(); setTimeout(update, 400); setTimeout(update, 1500); }
  document.addEventListener("change", function (e) {
    var t = e.target;
    if (t && t.closest && t.closest("variant-picker")) schedule();
  });
  // The finder redraws its trouser buttons whenever something changes; follow its pick.
  function watchFinder() {
    var g = document.getElementById("ssz-pant");
    if (!g || g.__tcWatched) return;
    g.__tcWatched = true;
    new MutationObserver(fromFinder).observe(g, { childList: true, subtree: true, attributes: true, attributeFilter: ["aria-pressed"] });
  }
  function boot() { schedule(); watchFinder(); setInterval(function () { update(); watchFinder(); }, 1000); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
